import React from 'react';

type IconProps = {
  width?: number | string;
  height?: number | string;
  fill?: string;
};

const TimeZoneComponent: React.FC<IconProps> = ({
  width = 23,
  height = 23,
  fill = 'none',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 23 23"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="10.5" cy="10.5" r="9.75" stroke="white" strokeWidth="1.5" />
    <path
      d="M10.5 0.75C10.8677 0.75 11.2805 0.921123 11.7246 1.35938C12.1719 1.80081 12.6089 2.4767 12.9922 3.37109C13.7577 5.15739 14.25 7.67718 14.25 10.5C14.25 13.3228 13.7577 15.8426 12.9922 17.6289C12.6089 18.5233 12.1719 19.1992 11.7246 19.6406C11.2805 20.0789 10.8677 20.25 10.5 20.25C10.1323 20.25 9.71945 20.0789 9.27539 19.6406C8.82815 19.1992 8.39113 18.5233 8.00781 17.6289C7.24228 15.8426 6.75 13.3228 6.75 10.5C6.75 7.67718 7.24228 5.15739 8.00781 3.37109C8.39113 2.4767 8.82815 1.80081 9.27539 1.35938C9.71945 0.921123 10.1323 0.75 10.5 0.75Z"
      stroke="white"
      strokeWidth="1.5"
    />
    <path
      d="M20.25 10.5C20.25 10.8677 20.0789 11.2805 19.6406 11.7246C19.1992 12.1719 18.5233 12.6089 17.6289 12.9922C15.8426 13.7577 13.3228 14.25 10.5 14.25C7.67718 14.25 5.15739 13.7577 3.37109 12.9922C2.4767 12.6089 1.80081 12.1719 1.35937 11.7246C0.921123 11.2805 0.75 10.8677 0.75 10.5C0.75 10.1323 0.921123 9.71945 1.35937 9.27539C1.80081 8.82815 2.4767 8.39113 3.37109 8.00781C5.15739 7.24227 7.67718 6.75 10.5 6.75C13.3228 6.75 15.8426 7.24228 17.6289 8.00781C18.5233 8.39113 19.1992 8.82815 19.6406 9.27539C20.0789 9.71945 20.25 10.1323 20.25 10.5Z"
      stroke="white"
      strokeWidth="1.5"
    />
    <g filter="url(#filter0_d_3414_1101)">
      <circle cx="17" cy="17" r="5" fill="#130951" />
      <circle cx="17" cy="17" r="4.25" stroke="white" strokeWidth="1.5" />
    </g>
    <path
      d="M17 15V17.1429L18 18"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <defs>
      <filter
        id="filter0_d_3414_1101"
        x="11"
        y="11"
        width="12"
        height="12"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius="1"
          operator="dilate"
          in="SourceAlpha"
          result="effect1_dropShadow_3414_1101"
        />
        <feOffset />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0745098 0 0 0 0 0.0352941 0 0 0 0 0.317647 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3414_1101"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3414_1101"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default TimeZoneComponent;
